import Controller from '@ember/controller'
import { tracked } from '@glimmer/tracking'
import type { DrivingTestsMathsRoute } from 'teacher-ui-client/reporting/ui-scope/maths/driving-tests/route'

export class DrivingTestsMathsController extends Controller<ModelFor<DrivingTestsMathsRoute>> {
  queryParams = ['drivingTestsGrade']

  @tracked drivingTestsGrade = 0

  setDrivingTestsGrade = (dtGrade: number) => {
    this.drivingTestsGrade = dtGrade
  }
}

export default DrivingTestsMathsController
